export function jsonParse<T = unknown>(text: string, defaultValue?: T): T {
    try {
        return typeof text === 'string' ? JSON.parse(text) : defaultValue;
    } catch {
        return defaultValue;
    }
}
